import CylinderCollectionItem from './cylinder_collection_item';

export default CylinderCollectionItem;
